import * as React from 'react';

export type CoachingReviewViewMode = 'list' | 'cards' | 'scoreboard';

const STORAGE_KEY = 'ai-coaching-review:view-mode';
const DEFAULT_MODE: CoachingReviewViewMode = 'list';

const isViewMode = (value: string | null): value is CoachingReviewViewMode =>
	value === 'list' || value === 'cards' || value === 'scoreboard';

const readStoredMode = (): CoachingReviewViewMode => {
	try {
		const stored = window.localStorage.getItem(STORAGE_KEY);
		return isViewMode(stored) ? stored : DEFAULT_MODE;
	} catch {
		return DEFAULT_MODE;
	}
};

export function useCoachingReviewViewMode() {
	const [mode, setModeState] = React.useState<CoachingReviewViewMode>(readStoredMode);

	const setMode = React.useCallback((next: CoachingReviewViewMode) => {
		setModeState(next);
		try {
			window.localStorage.setItem(STORAGE_KEY, next);
		} catch {
			// Ignore write failures (private mode / storage disabled) — in-memory state still updates.
		}
	}, []);

	return [mode, setMode] as const;
}
